const itemStatuses = Object.freeze({
  PendingInformation: 27,
  Resolved: 3,
});

export default itemStatuses;
